const stedsnavn = {
	searchForPlace: "Søk etter sted"
};

export default stedsnavn;
export { stedsnavn };
